const THOUSAND = 1000;
const MILLION = 1000000;

export const formatTokens = (num: number) => {
  if (num < THOUSAND) {
    return '< 1k';
  } else if (num < MILLION) {
    return `${Math.round(num / THOUSAND)}k`;
  } else {
    return `${Math.round(num / MILLION)}M`;
  }
};

export const doubleEncodeUriComponent = (str: string) => {
  return encodeURIComponent(encodeURIComponent(str));
};

export const doubleDecodeUriComponent = (str: string) => {
  return decodeURIComponent(decodeURIComponent(str));
};
